<script>
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import Claim from '$lib/PageSections/Forms/Claim/Claim.svelte';

	let { data } = $props();
</script>

<Section backgroundColor="white">
	<Claim {data} />
</Section>
